var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.WidgetBaseComponent, {
    directives: [
      {
        name: "resize",
        rawName: "v-resize",
        value: _setup.checkTruncation,
        expression: "checkTruncation",
      },
    ],
    staticClass: "last-actions-widget",
    attrs: { loadedData: _setup.allDataLoaded && !_setup.showSpinner },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", { staticClass: "header-container" }, [
              _c("h2", [_vm._v(_vm._s(_setup.widgetData.title))]),
              _c("span", {
                class: [_setup.openWindowIcon, "lf-icon__md", "header-icon"],
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _setup.goToActions.apply(null, arguments)
                  },
                },
              }),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "section",
              { staticClass: "body-container element-with-scroll" },
              [
                _setup.widgetData.body.cells.length
                  ? _c("table", { staticClass: "last-actions-table" }, [
                      _c("thead", [
                        _c(
                          "tr",
                          _vm._l(
                            _setup.widgetData.body.headers,
                            function (header, headerIndex) {
                              return _c(
                                "th",
                                {
                                  key: headerIndex,
                                  class: header.toLowerCase(),
                                },
                                [_vm._v(" " + _vm._s(header) + " ")]
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                      _c(
                        "tbody",
                        _vm._l(_setup.typedCells, function (row, rowIndex) {
                          return _setup.widgetData.body.cells.length !== 0
                            ? _c(
                                "tr",
                                {
                                  key: rowIndex,
                                  on: {
                                    click: function ($event) {
                                      return _setup.openActionInNewWindow(
                                        row.idType,
                                        row.idAction
                                      )
                                    },
                                  },
                                },
                                _vm._l(
                                  _setup.widgetData.body.headers,
                                  function (_cell, cellIndex) {
                                    return _c("td", { key: cellIndex }, [
                                      cellIndex === 0
                                        ? _c("span", {
                                            class: [
                                              _setup.checkActionIcon(
                                                row["idType"]
                                              ),
                                              "table-icon",
                                            ],
                                          })
                                        : _vm._e(),
                                      cellIndex === 1
                                        ? _c(
                                            "div",
                                            [
                                              _setup.isTruncatedItems[rowIndex]
                                                ? _c(
                                                    _setup.LexonTooltipComponent,
                                                    {
                                                      attrs: {
                                                        message:
                                                          Object.values(row)[
                                                            cellIndex + 2
                                                          ],
                                                        position: "top",
                                                        isWidthAuto: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator-element",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    ref: (el) =>
                                                                      _setup.setRef(
                                                                        el,
                                                                        rowIndex
                                                                      ),
                                                                    refInFor: true,
                                                                    staticClass:
                                                                      "truncated",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        Object.values(
                                                                          row
                                                                        )[
                                                                          cellIndex +
                                                                            2
                                                                        ]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      ref: (el) =>
                                                        _setup.setRef(
                                                          el,
                                                          rowIndex
                                                        ),
                                                      refInFor: true,
                                                      staticClass: "truncated",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          Object.values(row)[
                                                            cellIndex + 2
                                                          ]
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          )
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                Object.values(row)[
                                                  cellIndex + 2
                                                ]
                                              )
                                            ),
                                          ]),
                                    ])
                                  }
                                ),
                                0
                              )
                            : _vm._e()
                        }),
                        0
                      ),
                    ])
                  : _c("div", { staticClass: "empty-table" }, [
                      _vm._v(_vm._s(_setup.emptyTableText)),
                    ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }